import { render } from "./AddCorrectionRequestPage.vue?vue&type=template&id=37e5e998&ts=true"
import script from "./AddCorrectionRequestPage.vue?vue&type=script&lang=ts"
export * from "./AddCorrectionRequestPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__